import { Dispatch, FC, SetStateAction } from "react";
import { Collapse } from "antd";
import parse from "html-react-parser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import BasicBadge from "@components/core/badges/BasicBadge";
import { AccordionSection } from "@components/core/accordions/Accordions";

const { Panel } = Collapse;

interface FormAccordionsProps {
  activeTab: number;
  setActiveTab: Dispatch<SetStateAction<number>>;
  sections: AccordionSection[];
  className?: string;
}

const FormAccordions: FC<FormAccordionsProps> = ({
  activeTab,
  setActiveTab,
  sections = [],
  className = "",
}) => {
  return (
    <Collapse
      className={`app-accordions-form ${className}`}
      accordion
      activeKey={activeTab}
      onChange={(key: string | string[]) => setActiveTab(parseInt(key[0], 10))}
      expandIconPosition="end"
      expandIcon={() => (
        <FontAwesomeIcon icon={faChevronDown} className="dropdown-chevron" />
      )}
    >
      {sections.map((section: AccordionSection, index: number) => (
        <Panel
          key={index + 1}
          header={
            <h3 data-test="accordions-section-header" data-alt={section.title}>
              <BasicBadge variant="tertiary" number={index + 1} />
              {section.title}
            </h3>
          }
          collapsible={activeTab > index + 1 ? undefined : "disabled"}
          showArrow={activeTab > index + 1}
        >
          <div data-test="accordions-section-content" data-alt={section.title}>
            {typeof section.content === "string"
              ? parse(section.content)
              : section.content}
          </div>
        </Panel>
      ))}
    </Collapse>
  );
};

export default FormAccordions;
